import React from 'react';
import {FlexColumn, FlexRow, Frame, Modal, Text} from '@forecast-it/design-system';
import {FormattedHTMLMessage, useIntl} from 'react-intl';

type DisableIntegrationWarningModalProps = {
	integration: string;
	removeCallback: () => void;
	closeModal: () => void;
};

const DisableIntegrationWarningModal = ({
	integration,
	removeCallback,
	closeModal,
}: DisableIntegrationWarningModalProps): JSX.Element => {
	const {formatMessage} = useIntl();
	const lowerCasedIntegrationName = integration.toLowerCase();

	const removeHandler = () => {
		removeCallback();
		closeModal();
	};

	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				{formatMessage({id: `settings.app_catalog.${lowerCasedIntegrationName}.warning_modal_title`})}
			</Modal.Title>
			<Modal.Content>
				<Text>
					<FormattedHTMLMessage id={`settings.app_catalog.${lowerCasedIntegrationName}.warning_modal_desc_1`} />
				</Text>

				<Frame>
					<FlexColumn gap={'m'}>
						<FlexRow gap={'m'}>
							<ul>
								<li>
									{formatMessage({
										id: `settings.app_catalog.${lowerCasedIntegrationName}.warning_modal_desc_2`,
									})}
								</li>
								<li>
									{formatMessage({
										id: `settings.app_catalog.${lowerCasedIntegrationName}.warning_modal_desc_3`,
									})}
								</li>
							</ul>
						</FlexRow>
					</FlexColumn>
				</Frame>
				<Text>{formatMessage({id: 'settings.app_catalog.warning_modal_desc_4'})}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={removeHandler}>
					{formatMessage({id: 'common.remove'})}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					{formatMessage({id: 'common.close'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default DisableIntegrationWarningModal;
